export default __webpack_public_path__ + "static/media/device_pending.858e0013.png";